var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7,7.06H8a8,8,0,0,1,1,.05,1.46,1.46,0,0,1,1,.72,1.36,1.36,0,0,1,.17.67,1.32,1.32,0,0,1-.8,1.24,1.43,1.43,0,0,1,.8.52,1.35,1.35,0,0,1,.28.86,1.7,1.7,0,0,1-.18.76,1.43,1.43,0,0,1-.49.59,1.58,1.58,0,0,1-.78.27c-.19,0-.66,0-1.39,0H5.7ZM6.85,8V9.33h.76a7.62,7.62,0,0,0,.84,0,.78.78,0,0,0,.47-.2.69.69,0,0,0,0-.88A.65.65,0,0,0,8.51,8c-.12,0-.45,0-1,0Zm0,2.28v1.53H7.92a4.4,4.4,0,0,0,.8,0,.68.68,0,0,0,.42-.23.73.73,0,0,0,.16-.48.72.72,0,0,0-.13-.44.65.65,0,0,0-.36-.26,3.72,3.72,0,0,0-1-.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid12);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_12.98592eb664678b19e2c8f53966c52ad9.svg";
export { ForwardRef as ReactComponent };